<template>
    <div class="container step step1">
        <div class="card-container">
            <a href="#" class="question" @click.prevent="pageChange = !pageChange">
                <img src="../../assets/step1/page1_question.png" v-if="pageChange == false" alt="">
                <img src="../../assets/step1/page1_question_change.png" v-if="pageChange" alt="">
            </a>
            <img src="../../assets/step1/page1_card.png" class="card" alt="">
            <img src="../../assets/step1/page1_people.png" class="people" alt="">
        </div><!-- card container end sub -->
        <img src="../../assets/step1/page1_bg.jpg" class="bg" alt="">
        <router-link to="/step1-1" class="btn-next el-icon-arrow-right"></router-link>
    </div>
</template>

<script>
export default {
  name: 'step1',
  data () {
    return {
      pageChange: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/step1/index.vue